import { makeStyles } from 'tss-react/mui';

const MENU_SPACING = 8;
const MENU_BORDER_RADIUS = 8;

const useFilterV3Styles = makeStyles()((theme) => ({
  menuOpened: {
    backgroundColor: '#F5F5F5',
  },
  arrowIconRotate: {
    transform: 'rotate(180deg)',
  },
  customButtons: {
    borderRadius: MENU_BORDER_RADIUS,
    marginTop: MENU_SPACING,
  },
  menu: {
    [theme.breakpoints.down('sm')]: {
      borderRadius: '16px 16px 0 0',
      minWidth: 'auto',
      minHeight: '90%',
    },
    minWidth: 296,
    overflowY: 'auto',
    overflowX: 'hidden',
    maxHeight: 'min(70vh, 515px)',
    overscrollBehavior: 'none',
  },
  mobileFilterButton: {
    border: `1px dashed ${theme.palette.divider}`,
    backgroundColor: theme.palette.background.default,
    color: theme.palette.text.primary,
    height: 28,
    '&:focus': {
      backgroundColor: theme.palette.background.default,
    },
  },
  mobileHeader: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gridGap: 20,
    padding: '12px',
    position: 'sticky',
    top: 0,
    zIndex: 999,
    backgroundColor: 'white',
  },
}));

export default useFilterV3Styles;
